import React from "react";
import styles from "./StoreButton.module.scss";

interface StoreButtonProps {
  href: string;
  src: string;
  alt: string;
}

export const StoreButton: React.FC<StoreButtonProps> = ({ href, src, alt }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.storeLink}
    >
      <img src={src} alt={alt} className={styles.storeBadge} />
    </a>
  );
};